module.exports = __webpack_public_path__ + "img/startPoint.77fd3921.png";